// The draft-editable fields of a site, in one place so the draft and the diff
// stay in sync.
const EDITABLE_FIELDS = ['title', 'domain', 'logo'];

// First letter for the logo fallback, from the domain (dropping a www./m.
// prefix) or the title.
export function siteInitial(site) {
  const source = (site.domain || site.title || '').replace(/^(www|m)\./, '');
  return source ? source[0].toUpperCase() : '?';
}

// Editable snapshot of a site.
export function buildDraft(site) {
  return {
    title: site.title || '',
    domain: site.domain || '',
    logo: site.logo || '',
  };
}

// Patch of only the fields that actually changed.
export function diffDraft(site, draft) {
  const patch = {};
  EDITABLE_FIELDS.forEach((field) => {
    if ((site[field] || '') !== draft[field]) {
      patch[field] = draft[field];
    }
  });
  return patch;
}
